/* eslint-disable import/prefer-default-export */
// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { createSelector } from 'reselect';
import { RootState } from 'Store';

const selectSelectedAdditionals = (state: RootState) => state.bundle.selectedAdditionals;
const selectAdditionalDeliverables = (state: RootState) => state.bundle.additionalDeliverables;

const selectSelectedBundle = createSelector(
  [selectSelectedAdditionals],
  (selectedAdditionals) => {
    const extraDeliverablesLength = selectedAdditionals.filter((u) => u.type === 'deliverable').length;
    const extraLayersLength = selectedAdditionals.filter((u) => u.type === 'layer').length;
    const addOnCount = extraDeliverablesLength + extraLayersLength;
    return {
      extraDeliverablesLength,
      extraLayersLength,
      addOnCount,
    };
  },
);

const selectDependencyNames = createSelector(
  [selectAdditionalDeliverables, (_, addOn) => addOn],
  (additionalDeliverables, addOn) => {
    const names = addOn.dependencies.map((dep: any) => {
      const deliverable = additionalDeliverables.find((b) => b._id === dep);
      if (deliverable) {
        return deliverable.name;
      }
      return undefined;
    }).filter((name: string) => name !== undefined);
    return names;
  },
);

export {
  selectSelectedBundle,
  selectDependencyNames,
};
